import { PageInfoService, UTMTrackerService } from '@pulse/browser-shared';

export class LegacySourceService {
    private engineList = new RegExp(
        [
            'google',
            'bing',
            'baidub',
            'yahoo',
            'yandex',
            'ask',
            'duckduckgo',
            'naver',
            'aol',
            'seznam',
        ].join('|'),
    );

    constructor(
        private utmService: UTMTrackerService,
        private page: PageInfoService,
    ) {}

    getSource(): string | undefined {
        const referrer = (this.page.referrer() || '').replace(/^https?:\/\//, '');
        const utm = this.utmService.getUTMParams();

        if (utm?.utm_source) {
            return `utm_${utm.utm_source}`;
        } else if (!referrer) {
            return 'direct';
        } else if (this.engineList.test(referrer)) {
            return `search_${referrer}`;
        } else {
            return `referral_${referrer}`;
        }
    }
}
